@for (contentPlaceholderRow of contentPlaceholderRows; track trackByIndex($index)) {
  <div class="mat-sticky-table-content-placeholder-row">
    <div>
      <div class="mat-sticky-table-content-placeholder-cell first"></div>
      <div class="mat-sticky-table-content-placeholder-cell"></div>
    </div>
    <div class="mat-sticky-table-content-placeholder last"></div>
  </div>
}
